import React from 'react'

/**
 * Calls a callback after a delay using an interval
 * @param delay Time in milliseconds between calls
 * @param action Function to call after the delay, needs to be wrapped in useCallback
 */
const useInterval = (delay: number, action: () => void) => {
  const actionRef = React.useRef<() => void>(null)

  React.useEffect(() => {
    actionRef.current = action
  }, [action])

  React.useEffect(() => {
    actionRef.current && actionRef.current()

    const interval = setInterval(() => {
      actionRef.current && actionRef.current()
    }, delay)

    return () => clearInterval(interval)
  }, [delay])
}

export default useInterval
